(() => {
  const visibleContentClass = "calculator-tabs__content--visible";
  const selectedOptionClass = "calculator-tabs__tab--selected";

  const show = (packedElement) => {
    packedElement.content.forEach(element => element.classList.add(visibleContentClass));
    packedElement.option.classList.add(selectedOptionClass);
    packedElement.content[0].dispatchEvent(new CustomEvent('calculator:invalidate'));
  };

  const hide = (packedElement) => {
    packedElement.content.forEach(element => element.classList.remove(visibleContentClass));
    packedElement.option.classList.remove(selectedOptionClass);
  };

  const initializeTab = (tabElement) => {
    const tabIndex = new URL(window.location.href).searchParams.get("tab");

    const optionElements = Array.from(
      tabElement.querySelectorAll('[data-calc-type="option"]')
    );
    const contentElements = Array.from(
      tabElement.querySelectorAll('[data-calc-type="content"]')
    );

    const packedElements = optionElements.map((optionElement) => {
      const name = optionElement.dataset.calcName;
      const suitableContentElements = contentElements.filter(element => element.dataset.calcName === name);

      return {
        content: suitableContentElements,
        option: optionElement,
      };
    });

    let selectedElement = packedElements[0];

    if (document.referrer) {
      const referrerUrl = new URL(document.referrer);
      if (
        [
          "/collections/dienines-romanetes",
          "/collections/naktines-romanetes",
        ].includes(referrerUrl.pathname)
      ) {
        selectedElement = packedElements[1];
      }
    }

    if (tabIndex !== undefined) {
      selectedElement = packedElements[+tabIndex];
    }

    show(selectedElement);

    for (const element of packedElements) {
      element.option.addEventListener("click", () => {
        hide(selectedElement);
        show(element);
        selectedElement = element;
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("tab", packedElements.indexOf(element));
        window.history.replaceState(
          undefined,
          undefined,
          currentUrl.toString()
        );
      });
    }
  };
  const tabs = document.querySelectorAll('[data-calc-type="tabs"]');
  tabs.forEach(initializeTab);

  window.calculatorConfig = window.calculatorConfig || {};
  window.calculatorConfig.curtain = () => ({
    defaultValues: {
      length: 0,
      coefficient: _shuttersc[3],
      isHangingRequired: _shuttersc[4],
    },
    _: false,
    __: function () {
      const {
        coefficient: rawCoefficient,
        length,
        isHangingRequired: rawIsHangingRequired,
      } = arguments[0];

      if (!Number.isFinite(length)) {
        throw new Error("Length is not finite.");
      }

      if (length < 0 || length > 56) {
        throw new Error("Length should be in range [0, 56].");
      }

      const coefficient = +rawCoefficient;
      const isHangingRequired = +rawIsHangingRequired;

      let totalMeters = coefficient * length;
      if (totalMeters > 0) {
        totalMeters += 0.3;
      }
      const curtainPrice = totalMeters * _shuttersc[0];
      const totalSewingPrice = totalMeters * _shuttersc[1];
      const totalHangingPrice = totalMeters * _shuttersc[2] * isHangingRequired;

      return {
        meters: `${totalMeters.toFixed(2)} m.`,
        curtainPrice,
        sewingPrice: totalSewingPrice,
        hangingPrice: totalHangingPrice,
      };
    },
  });
  window.calculatorConfig.romanette = () => ({
    defaultValues: {
      length: 0,
      height: 0,
      isHangingRequired: "1",
      isMountingRequired: "1",
    },
    _: false,
    __: function () {
      const {
        length,
        height,
        isHangingRequired: rawIsHangingRequired,
        isMountingRequired: rawIsMountingRequired,
      } = arguments[0];
      const FieldError = arguments[1];

      const isHangingRequired = +rawIsHangingRequired;
      const isMountingRequired = +rawIsMountingRequired;

      if (!Number.isFinite(length)) {
        throw new Error("Length is not finite number");
      }

      if (length < 0 || length > 6) {
        throw new Error("Length should be in range [0, 6]");
      }

      if (!Number.isFinite(height)) {
        throw new Error("Height is not finite number");
      }

      if (height < 0 || height > 3) {
        throw new Error("Height should be in range [0, 3]");
      }

      const heightMultiplier = height === 0 ? 0 : 1;
      const totalLength = heightMultiplier * (length + 0.3 * (length > 0));
      const textilePrice = heightMultiplier * totalLength * _shutters[0];
      const totalMechanismPrice = heightMultiplier * length * _shutters[4];
      const totalSewingPrice = length * height * _shutters[1];
      const totalHangingPrice = heightMultiplier * length * _shutters[2] * isHangingRequired;
      const totalMountingPrice =
        heightMultiplier * Math.max(2, Math.ceil(length / 0.6)) * _shutters[3] * isMountingRequired * (length > 0);

      return {
        meters: `${totalLength.toFixed(2)} m.`,
        textilePrice,
        mechanismPrice: totalMechanismPrice,
        sewingPrice: totalSewingPrice,
        hangingPrice: totalHangingPrice,
        mountingPrice: totalMountingPrice,
      };
    },
  });
})();
